import { Box, Link, Typography } from "@mui/material"
import useAppStore from "store/app"

const SignIn = () => {
  const t = useAppStore((state) => state.translations)

  return (
    <Box sx={{ my: 2.5, display: "flex", justifyContent: "center" }}>
      <Typography variant="body1">{t?.data?.pages?.login_page?.no_account}</Typography>
      <Link sx={{ cursor: "pointer", textDecoration: "none", ml: 1 }} href="/registration">
        <Typography variant="body1">{t?.data?.pages?.home?.registration}</Typography>
      </Link>
    </Box>
  )
}

export default SignIn
